import { combineReducers } from 'redux';
import AuthReducer from './reducer_authentication';
import RegistrationReducer from './reducer_registration';
import CompanyReducer from './reducer_company';
import SiteTrackingReducer from './reducer_siteTracking';
import StorageReducer from './reducer_storage';
import ThemeReducer from './reducer_theme';
import PermissionsReducer from './reducer_permissions';
import ToursReducer from './reducer_tour';

const rootReducer = combineReducers({
	auth_status: AuthReducer,
	registration_status: RegistrationReducer,
	company_info: CompanyReducer,
	site_tracking: SiteTrackingReducer,
	permissions: PermissionsReducer,
	storage: StorageReducer,
	theme: ThemeReducer,
	tours: ToursReducer,
});

export default rootReducer;
